import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import classnames from "classnames";
import format from "date-fns/format";

import constants, {
  getDashboardPath,
  NO_DATA_FOUND,
} from "../../../../constants";
import * as actions from "../../../../store/actions";
import { getUserData } from "../../../../utils/localStorage";

import "./ScheduleAppointment.css";

import CustomDatePicker from "../../../../components/formElements/datepicker/CustomDatePicker";
import AcceptModal from "../PopupModal/AcceptModal";
import { convertTimeTo12HourFormat } from "../../../../utils/parseDateTime";
import AppointmentDetailInfo from "../AppointmentDetail/AppointmentDetailInfo";

const ScheduledAppointment = ({
  appointmentData,
  setAppointmentData,
  getScheduledAppointments,
  updateAppointmentStatus,
  appointmentSessionCreation,
  updateGuestDoctorRequest,
  placeHoldOnCard,
  history,
}) => {
  const [isOpen, setIsOpen] = useState(undefined);
  
  const selectedScheduleDate = format(
    appointmentData?.selectedScheduleDate || new Date(),
    "yyyy-MM-dd"
  );

  useEffect(() => {
    setAppointmentData({ selectedScheduleDate: new Date() });
    
    //eslint-disable-next-line

  }, []);
  
  useEffect(() => {
    getScheduledAppointments(1, selectedScheduleDate);
    // eslint-disable-next-line
  }, [appointmentData?.selectedScheduleDate]);
  let openModal = value => {
    setIsOpen(value);
  };
  let closeModal = () => {
    setIsOpen(undefined);
  };
  const isGuest =
    appointmentData?.schAppointmentDetail?.guest_doctor_id ===
    getUserData()?.id;

  return (
    <>
      <AcceptModal
        isOpen={isOpen}
        closeModal={() => closeModal()}
        appointmentData={appointmentData?.schAppointmentDetail}
        onAcceptSuccess={() =>
          getScheduledAppointments(1, selectedScheduleDate)
        }
        onUpdate={isGuest ? updateGuestDoctorRequest : updateAppointmentStatus}
        rescheduleType="scheduled"
      />
      <div className="row ml-n4 pt-3 scheduled">
        <div
          className="col-md-auto"
          style={{
            background: "var(--header-color)",
            textAlign: "center",
          }}
        >
          <CustomDatePicker
            value={appointmentData.selectedScheduleDate}
            onChange={date =>{
              setAppointmentData({ selectedScheduleDate: date });
              // Appointment_time();
            }}
            scheduledDates={appointmentData?.scheduledAppointments}
          />
          <ul className="slotDate mt-2">
            <li className="mb-3 slotTitle">
              {format(
                appointmentData?.selectedScheduleDate || new Date(),
                "MMMM dd, yyyy"
              )}
            </li>
          </ul>
          <ul className="slotList mt-2">
            {appointmentData.scheduled &&
              appointmentData?.scheduled[selectedScheduleDate]?.map(apt => (
                <li
                  className={classnames(
                    "scheduledSlot mb-1",
                    apt?.id === appointmentData?.schAppointmentDetail?.id
                      ? "activeslot"
                      : "inactiveslot"
                  )}
                  onClick={() => {
                    setAppointmentData({ schAppointmentDetail: apt} );
                  }}
                >
                  <p className="slotTitle">{apt.patientName}</p>
                  <p className="slotTime">
                    {convertTimeTo12HourFormat(apt.startTime)}- {convertTimeTo12HourFormat(apt.endTime)}
                  </p>
                </li>
              ))}
          </ul>
        </div>
        <div className="col-md-7 pl-4 mt-3">
          {appointmentData?.schAppointmentDetail?.appointmentDate ===
          selectedScheduleDate ? (
            <AppointmentDetailInfo
              appointmentData={appointmentData.schAppointmentDetail}
              type={appointmentData.schAppointmentDetail?.status=="ACCEPTED" && "scheduled"}
              
              onReschedule={() => openModal("reschedule")}
              onCancel={() => openModal("cancel")}
              onEnd={() => openModal("End call")}
              onStart={appointmentId => {
                if (!appointmentData.schAppointmentDetail?.is_subscribed_patient) {
                  placeHoldOnCard(appointmentId)
                }
                appointmentSessionCreation(appointmentId, () =>
                    history.push({
                      pathname: getDashboardPath("/appointments/start-call"),
                      state: { appointment_type: "future_appointment" },
                    })
                )
              } 
              }
              onGuestSuccess={() =>
                getScheduledAppointments(1, selectedScheduleDate)
              }
              onCancelInvite={updateGuestDoctorRequest}
            />
          ) : (
            <p className="content-center m-auto not-found-image">
              <img
                src={NO_DATA_FOUND}
                width={366}
                height={300}
                alt="schedule-not-found"
              />
            </p>
          )}
        </div>
      </div>
    </>
  );
}
const mapStoreToProps = ({ dashboard }) => ({
  appointmentData: dashboard.appointments,
});
const mapDispatchToProps = dispatch => ({

  getScheduledAppointments: (page, date) =>
     
    dispatch(actions.getAppointments(
        [constants.APPOINTMENT_STATUS.accepted,constants.APPOINTMENT_STATUS.cancelled,constants.APPOINTMENT_STATUS.completed,
        constants.APPOINTMENT_STATUS.noshow],
        page,
        date
      )
    ),
  
    
  setAppointmentData: updatedData =>
    dispatch(actions.setAppointmentData(updatedData)),
  updateAppointmentStatus: (id, status, cb) =>
    dispatch(actions.updateAppointmentStatus(id, status, cb)),
  appointmentSessionCreation: (appointmentId, cb) =>
    dispatch(
      actions.appointmentSessionCreation(appointmentId, "appointment", true, cb)
    ),
  updateGuestDoctorRequest: (id, status, cb) =>
    dispatch(actions.updateGuestDoctorRequest(id, status, cb)),
  placeHoldOnCard: (appointmentId, cb) =>
    dispatch(actions.placeHoldOnCard(appointmentId, "APPOINTMENT", cb)),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(ScheduledAppointment)
);
